import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {EmptyMessage} from "../../../../../lib/util/messages";
import {StringKey} from "../../../../../app.string-keys";
import {Set} from "immutable";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import {TaskRecordService} from "../../../../../lib/task/task-record.service";
import {NgbDatePickerParserFormatter} from "../../../../../util/ngb-datepicker";
import {DeadlineModificationModel} from "../../../../../util/task-record-utils";
import {UiConstants} from "../../../../../util/core-utils";
import {ToasterService} from "../../../../../fork/angular2-toaster/src/toaster.service";
import {TranslateService} from "@ngx-translate/core";
import {FormBuilder, FormGroup, NgForm, Validators} from "@angular/forms";
import {ForwardingNgFormRef, LocalFormGroupValidationErrors} from "../../../../../lib/util/services";
import {AppValidators} from "../../../../../util/app-validators";

@Component({
  selector: 'app-task-record-date-change-dialog',
  templateUrl: './task-record-date-change-dialog.component.html',
  styleUrls: ['./task-record-date-change-dialog.component.scss']
})
export class TaskRecordDateChangeDialogComponent implements OnInit {

  model: DeadlineModificationModel = new DeadlineModificationModel();

  @ViewChild('f', {static: true})
  form: NgForm;
  formGroup: FormGroup;
  private formGroupValidationErrors: LocalFormGroupValidationErrors;

  constructor(public dialogRef: MatDialogRef<TaskRecordDateChangeDialogComponent>,
              private taskRecordService: TaskRecordService,
              private fb: FormBuilder,
              private dateParser: NgbDatePickerParserFormatter,
              private toasterService: ToasterService,
              private translateService: TranslateService,
              @Inject(MAT_DIALOG_DATA) public data: TaskRecordDeadlineChangeDialogData
  ) {
    this.formGroup = this.createFormGroup(this.fb);
    this.formGroupValidationErrors = LocalFormGroupValidationErrors.ofForm(
      this.createForwardingHtmlForm(),
      this.formGroup
    );

  }

  ngOnInit(): void {
  }

  private createForwardingHtmlForm() {
    return new ForwardingNgFormRef({
      formFn: () => {
        return this.form;
      }
    });
  }

  private createFormGroup(fb: FormBuilder): FormGroup {
    return fb.group(
      {
        deadlineDate: fb.control(
          {value: this.model.deadlineDate},
          [Validators.required, AppValidators.validateLocalDate]
        ),
        deadlineTime: fb.control(
          {value: this.model.deadlineTime},
          [Validators.required]
        ),
      }
    );
  }

  hasLocalFieldError(formControlName?: string, errorCode?: string): boolean {
    return this.formGroupValidationErrors.hasFieldError(formControlName, errorCode);
  }


  save() {
    if (this.data.type === 'DEADLINE') {
    this.taskRecordService.changeDeadline({
      taskRecordIdSet: this.data.taskRecordIds,
      deadline:
        this.dateParser.toOffsetDateTime(this.model.deadlineDate, this.model.deadlineTime)
    }).subscribe((result: EmptyMessage) => {
      this.toasterService.pop({
        timeout: UiConstants.ToastTimeoutShort,
        type: UiConstants.toastTypeSuccess,
        title: this.translateService.instant(StringKey.TASKS_DATA_MODIFY),
        body: this.translateService.instant(StringKey.TASKS_DATA_MODIFY)
      });
      this.closeDialog(true);
    });
    } else {
      this.taskRecordService.changeAgreedTime({
        taskRecordIdSet: this.data.taskRecordIds,
        agreedTime:
          this.dateParser.toOffsetDateTime(this.model.deadlineDate, this.model.deadlineTime)
      }).subscribe((result: EmptyMessage) => {
        this.toasterService.pop({
          timeout: UiConstants.ToastTimeoutShort,
          type: UiConstants.toastTypeSuccess,
          title: this.translateService.instant(StringKey.TASKS_DATA_MODIFY),
          body: this.translateService.instant(StringKey.TASKS_DATA_MODIFY)
        });
        this.closeDialog(true);
      });
    }
  }

  static openDialog(dialog: MatDialog, data: TaskRecordDeadlineChangeDialogData, resultCallback: (result: TaskRecordDeadlineChangeDialogResult) => void) {
    const dialogRef = dialog.open(TaskRecordDateChangeDialogComponent, {
      closeOnNavigation: true,
      data: data,
      width: '60%',
      height: 'auto',
      panelClass: 'custom-dialog-container'
    });
    dialogRef.afterClosed().subscribe((result: TaskRecordDeadlineChangeDialogResult) => {
      resultCallback(result);
    });

  }

  closeDialog(success?: boolean) {
    this.dialogRef.close({success: success === undefined ? false : success});
  }
}

export class TaskRecordDeadlineChangeDialogData {
  taskRecordIds: Set<number>;
  type: 'DEADLINE' | 'AGREED_TIME';
}

export class TaskRecordDeadlineChangeDialogResult {
  success: boolean
}
